// Copyright (c) 2016 Deere & Company

export const buildLaborAdditiveSummariesObject = laborAdditiveSummaries => {

    let laborAdditiveSummariesObject;

    if (laborAdditiveSummaries.length <= 3) {

        laborAdditiveSummariesObject = {
            alwaysShowGroup: laborAdditiveSummaries,
            showMoreGroup: []
        };

    } else {

        const alwaysShowGroup = laborAdditiveSummaries.slice(0, 3);

        const showMoreGroup = laborAdditiveSummaries.slice(3, laborAdditiveSummaries.length);

        laborAdditiveSummariesObject = {
            alwaysShowGroup,
            showMoreGroup
        };

    }

    return laborAdditiveSummariesObject;

};



// WEBPACK FOOTER //
// ./src/pip/shared/services/build-labor-additive-summaries-object.js